export const CategoryTypeConstant = [
  {
    id: 1,
    name: 'Premium',
    nameKey: 'Premium',
  },
  {
    id: 2,
    name: 'Gold',
    nameKey: 'Gold',
  },
  {
    id: 3,
    name: 'Silver',
    nameKey: 'Silver',
  },
];
